import { getPRPC } from "../../../hooks/usePRPC";
import createRPCQuery from "../../../utils/createRPCQuery.util";
import { defaultLanguage } from "../../../assets/languages/langs";
import { store } from "../../store";

// TODO: rewrite. is not correct
export default function getReveal(point, params?: any) {
	const prpcow = getPRPC();

	if (!prpcow) throw Error(`prpcow didn't initialize`);

	const radius = store.getState().settings.map.revealRadiusMeters;
	const lang = store.getState().session.language || defaultLanguage;

	return createRPCQuery(() =>
		prpcow?.theirsModel.map.reveal(point, {
			...params,
			radius,
			lang,
		}),
	);
}
